module.exports = "https://web-assets.ifttt.com/packs/media/shared/google_pay_logo-8cb3186c.svg";